function getTimeInt(uuid) {
  const uuidArr = uuid.split('-');
  const timeStr = [uuidArr[2].substring(1), uuidArr[1], uuidArr[0]].join('');
  return parseInt(timeStr, 16);
}

export default function uuidToDate(uuid) {
  const intTime = getTimeInt(uuid) - 122192928000000000;
  const intMS = Math.floor(intTime / 10000);
  return new Date(intMS);
}
